import React from "react";
import _ from "lodash";
import moduleDetails from "../pages/moduleDetails";
import image from "../assets/images/coinLearn__image2.svg";
const Module = ({ match }) => {
  let moduleDetail = moduleDetails.filter(
    (m) => match.params.title === _.kebabCase(m.heading)
  );

  return moduleDetail && moduleDetail.length > 0 ? (
    <div className="Module">
      <div className="Module__container">
        <h1>{moduleDetail[0].heading}</h1>
        <div className="Module__Grid__container">
          <div className="Module__Grid__container__content">
            {moduleDetail[0].content.map((c, index) => (
              <>
                <h2>
                  {index + 1}. {c.heading}
                </h2>
                <p>{c.content}</p>
              </>
            ))}
          </div>
          <div>
            <img src={image} alt="coinLearnimage" />
          </div>
        </div>
        <button className="Download__button">Download PDF</button>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Module;
